











































import { Component, Prop } from 'vue-property-decorator';
import { EventBus } from '../helpers/bus';
import BaseComponent from './Base';

export interface QuestionnaireResult {
    answer: string | undefined;
    contact: boolean | undefined;
}

@Component
export default class Questionnaire extends BaseComponent {
    @Prop({ type: String, required: true }) protected readonly id: string;

    @Prop({ type: String, required: true }) protected readonly content: string;

    @Prop({ type: Object, required: true }) protected readonly options: { [key: string]: string };

    @Prop({ type: Boolean, required: true }) protected readonly pingBack: boolean;

    @Prop({ type: String, required: true }) protected readonly managerLogo: string;

    private innerAnswer: string | undefined;

    private innerContact: boolean | undefined;

    get answer(): string | undefined {
        return this.innerAnswer;
    }

    set answer(v: string | undefined) {
        this.innerAnswer = v;
        this.complete();
    }

    get contact(): boolean | undefined {
        return this.innerContact;
    }

    set contact(v: boolean | undefined) {
        this.innerContact = v;
        this.complete();
    }

    private complete() {
        EventBus.$emit(this.id, {
            answer: this.innerAnswer,
            contact: this.innerContact,
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Questionnaire.vue